module.exports = __webpack_public_path__ + "static/media/login-btn.b31c5cb8.png";